import React from "react";
import { useSelector } from "react-redux";
import { getLowerRoles } from "../pages/referral-dashboard/referralRoles";
import DashboardLayout from "../components/common/DashboardLayout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BadgeIcon from "@mui/icons-material/Badge";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";

const mainListItemsArray = [
  {
    id: 1,
    label: "Dashboard",
    link: "/referral",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    label: "Broker",
    link: "/referral/broker",
    icon: <AccountBalanceIcon />,
  },
  {
    id: 3,
    label: "BDM",
    link: "/referral/bdm",
    icon: <BadgeIcon />,
  },
  {
    id: 4,
    label: "Sub Broker",
    link: "/referral/sub-broker",
    icon: <GroupsIcon />,
  },
  {
    id: 5,
    label: "End User",
    link: "/referral/end-user",
    icon: <PersonIcon />,
  },
];

// sidebar link → referral_role it lists (Dashboard / End User have none, always shown)
const ITEM_ROLE = {
  "/referral/broker": "Broker",
  "/referral/bdm": "BDM",
  "/referral/sub-broker": "SubBroker",
};

export default function ReferralDashboardLayout() {
  const userState = useSelector((store) => store.auth);
  const lowerRoles = getLowerRoles(userState?.user?.userDetails?.referral_role);

  const items = mainListItemsArray.filter((item) => !ITEM_ROLE[item.link] || lowerRoles.includes(ITEM_ROLE[item.link]));

  return <DashboardLayout mainListItems={items} />;
}
